<!-- eslint-disable max-len -->
<template>
  <div
    id="login-html"
    class="login-html">
    <div class="login-box">
      <div class="d-flex flex-column align-items-center">
        <b-img
          :src="logo_company"
          height="164"/>
        <p class="login-title m__t--20">Sign in to your account</p>
      </div>
      <b-form
        @reset="onReset"
        @keyup.enter="onSubmit">
        <b-form-group>
          <b-form-input
            id="exampleInput1"
            v-model="$v.form.email.$model"
            :class="{'error-input' : $v.form.email.$error}"
            :error-message="null"
            placeholder="Email Address"
            style="border: 1px solid #D0D0D0;"
            type="email"/>
        </b-form-group>
        <b-form-group id="passwordInput">
          <b-form-input
            id="exampleInput2"
            :type="password_id"
            :error-message="null"
            :class="{'error-input' : $v.form.password.$error}"
            v-model="$v.form.password.$model"
            style="border: 1px solid #D0D0D0;"
            placeholder="Password"/>
          <label>
            <i
              :class="{'fa fa-eye': !show_pass, 'fa fa-eye-slash': show_pass}"
              role="img"
              @click="show_pass=!show_pass"/>
          </label>
        </b-form-group>
        <vue-recaptcha
          v-if="captcha_login"
          ref="recaptcha"
          :load-recaptcha-script="true"
          :sitekey="sitekey"
          class="g-recaptcha"
          @verify="onCaptchaVerified"
          @expired="onCaptchaExpired"/>
        <b-row class="mt-2">
          <b-col class="mt-4">
            <b-button
              id="btn-login"
              :class="{'disabled': $v.form.$invalid || (captcha_login && (!recaptchaToken || !publicKey))}"
              :disabled="$v.form.$invalid"
              @click="onSubmit">
              Login
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      <div
        v-if="withLDAP"
        class="other-signin"
      >
        <p>Or</p>
        <router-link
          to="/signin-with-ldap"
          class="btn-active-directory">
          Sign in with <span>Active Directory</span>
        </router-link>
      </div>
    </div>
    <div class="login-copy">
      <p>Version {{ version_code }}</p>
      <p>Powered by
        <b-link
          href="https://officeless.studio/"
          target="_blank">
          <strong>Jojonomic</strong>
        </b-link>
      </p>
    </div>

    <j-modal ref="modalOtp">
      <input-otp
        :otp-show="otp_show"
        :wait-time="data_otp ? data_otp.expired_millisecond : 12909309"
        mode="login"
        @close-modal="hideOtpModal"
      />
    </j-modal>
  </div>
</template>

<script>
/* eslint-disable no-console, max-len, no-return-await */
import { required, minLength } from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';
import VueRecaptcha from 'vue-recaptcha';
import inputOtp from '@/components/inputs/jInputOtp';
import jModal from '@/components/modal/jModal';

const NodeRSA = require('node-rsa');

export default {
  name: 'JLogin',
  components: {
    VueRecaptcha,
    inputOtp,
    jModal,
  },
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      show_pass: false,
      version_code: '2.64.5',
      key: {
        publicKey:
          'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCbwgUR4qyEHDm/S2EizPCnTIFgJrqN8SXYmDzZW6scOgz4ZM9IUDNa0lfIw2y8qcd+QS25ZXj+YrOyGhODyn3lD6hGR5NMwfQhV+kPAQEKft/Ub8+E3ITvQdZOCfpYALcMGZhgwWJQULuH2ThKriX4qHCuvkLnUYv/U9O5qU5dnQIDAQAB',
        privateKey:
          'MIICdQIBADANBgkqhkiG9w0BAQEFAASCAl8wggJbAgEAAoGBAJvCBRHirIQcOb9LYSLM8KdMgWAmuo3xJdiYPNlbqxw6DPhkz0hQM1rSV8jDbLypx35BLblleP5is7IaE4PKfeUPqEZHk0zB9CFX6Q8BAQp+39Rvz4TchO9B1k4J+lgAtwwZmGDBYlBQu4fZOEquJfiocK6+QudRi/9T07mpTl2dAgMBAAECgYAHHjfDGHvP0cZl0pkO0RTSYHGtJjfyUqnrGxH00Pah5JlBJMJASMIADYrLdvraKFwgjfP7/AIqhfI2WnC33iIgqnTp0q+mON5TZhZCR1W7iLe5LBVN5TlUbnIQfTtCu3IyfdNCDSO/Ok5ITZGYXLSwces7vwhk+0LXjILaTydY9QJBAMno8GGHNUcxt3xUi7xF5jGlX6y27MRLTA3eW6QQzR5huVWosG2saU7zgkhFlU38+Ei+XjgFyGP7jYX3QFNhNH8CQQDFe/Tq9ubMrxK4/d+IFcHha97apYunziNvlphzx94/gghQZPjcqPbQwpWw7LspiWe/Xxb59gD0lp1zvEPTxq/jAkAOqjSLYN6lxR6mkR11Fz6Y7IH+cWrQ9wcXGsddKzs6sa5cYlwuGw+rBFS6GxO1DmKaJfmB6Cmd2W92A3dQlwbRAkAuQe3Jh9HiCfQxvs24O5hxa+oEfxhqUv+76KOHIz7s01GNO0mLrkw59ApKKflhLl1N10EzhasNn6X78RJWLckPAkB4kGsvR7Q53V4tgNStJjYJS5LbxjOy15ld4Z4x/mJSKBgghisoAjrEvkrr4glcl3L9VLVICxrDsYmn5oGKfOpN',
      },
      publicKey: '',
      privateKey: '',
      nRSA: new NodeRSA(),
      decryptData: '',
      encryptData: '',
      otp_show: false,
      recaptchaToken: null,
    };
  },
  validations: {
    form: {
      email: {
        required,
      },
      password: {
        required,
        minLength: minLength(5),
      },
    },
  },
  computed: {
    ...mapState('jStoreLogin', ['data_otp']),

    password_id() {
      if (this.show_pass) {
        return 'text';
      }
      return 'password';
    },
    logo_company() {
      // eslint-disable-next-line
      return require('@/assets/img/studio-logo-new.png');
    },
    withLDAP() {
      return process.env.SIGNIN_WITH_LDAP === 'true';
    },
    login_otp() {
      return process.env.LOGIN_OTP === 'true';
    },
    captcha_login() {
      return process.env.CAPTCHA_LOGIN === 'true';
    },
    sitekey() {
      return process.env.SITE_KEY_RECAPTCHA;
    },
  },
  watch: {
    data_otp(val) {
      if (val) this.showOtpModal();
    },
  },
  created() {
    this.getKeyPublicRSA().then((res) => {
      if (res && !res.error) {
        this.publicKey = atob(res.data.key);
        // this.privateKey = atob(res.data.pkey);
        this.nRSA.importKey(this.publicKey, 'pkcs8-public-pem');
        // this.nRSA.importKey(this.privateKey, 'pkcs8-private-pem');
        this.nRSA.setOptions({ encryptionScheme: 'pkcs1' });
      }
    });
  },
  methods: {
    ...mapActions('jStoreLogin', ['loginAccount', 'loginAccountV2', 'getKeyPublicRSA', 'requestOtpLogin']),

    inputPublicKey() {
      this.nRSA.importKey(this.key.publicKey, 'pkcs8-public-pem');
    },
    inputPrivateKey() {
      this.nRSA.importKey(this.key.privateKey, 'pkcs8-private-pem');
    },
    async encryption(str) {
      return await this.nRSA.encrypt(str, 'base64');
    },
    async decryption(str) {
      return await this.nRSA.decrypt(str, 'utf8');
    },
    encrypt() {
      this.encryption(this.decryptData)
        .then((result) => {
          this.encryptData = result;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    decrypt() {
      this.decryption(this.encryptData)
        .then((result) => {
          this.decryptData = result;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSubmit() {
      if (this.captcha_login && this.recaptchaToken && this.publicKey) {
        this.encryption(this.form.password).then((result) => {
          this.$v.form.$touch();
          if (!this.form.email.match(/^[A-Za-z0-9@._-]+$/g)) {
            this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'Please input email correctly');
          } else if (!this.$v.form.$error) {
            const data = {
              email: this.form.email,
              password: result,
              token_recaptcha: this.recaptchaToken,
              app: 'studio',
            };
            if (this.login_otp) this.requestOtpLogin(data);
            else this.loginAccountV2(data);
          }
        }).catch((err) => { console.log(err); });
      } else if (!this.captcha_login) {
        this.encryption(this.form.password).then((result) => {
          this.$v.form.$touch();
          if (!this.form.email.match(/^[A-Za-z0-9@._-]+$/g)) {
            this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'Please input email correctly');
          } else if (!this.$v.form.$error) {
            const data = {
              email: this.form.email,
              password: result,
              app: 'studio',
            };
            if (this.login_otp) this.requestOtpLogin(data);
            else this.loginAccountV2(data);
          }
        }).catch((err) => { console.log(err); });
      }
    },
    onReset() {
      this.form.email = '';
      this.form.password = '';
      this.recaptchaToken = null;
    },
    showOtpModal() {
      this.$refs.modalOtp.toggleModal();
      this.otp_show = true;
    },
    hideOtpModal() {
      this.$refs.modalOtp.toggleModal();
      this.otp_show = false;
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
      this.recaptchaToken = null;
    },
    onCaptchaVerified(recaptchaToken) {
      this.recaptchaToken = recaptchaToken;
    },
  },
};
</script>
<style scoped>
#login-html.login-html{
  background-image: url('../../assets/img/bg-login.png') !important;
  background-size: contain cover;
  background-position: center center;
}

#login-html.login-html .login-box .login-title {
  font-size: 18px;
  text-align: center;
  color: '#4F4F4F';
}

#login-html.login-html .login-box .login-separator {
  font-size: 12px;
  text-align: center;
  color: #fff;
}

#login-html.login-html .login-box .btn {
  padding: 12px 0;
}

#login-html.login-html .login-box .b-form-group input[type='password'],
#login-html.login-html .login-box .b-form-group input[type='text'] {
  margin-top:15px;
}

#login-html.login-html .login-box .b-form-group input[type='password'],
#login-html.login-html .login-box .b-form-group input[type='text'] {
  padding-top:20px;
  padding-bottom:20px;
  background-image: url('../../assets/img/ico-lock.png') !important;
}

#login-html.login-html .login-box .b-form-group input[type='email'] {
  padding-top:20px;
  padding-bottom:20px;
  background-image: url('../../assets/img/ico-mail.png') !important;
}

#login-html.login-html .login-copy {
  position: absolute;
  color: white;
  bottom: 10px;
  text-align: center;
  width: 100%;
}

#login-html.login-html .login-copy p{
  margin: 10px 0;
  color: #F4F4F4;
  font-size: 11px;
}

#login-html.login-html .login-copy p strong{
  font-weight: bold;
  color: white;
}

#passwordInput, #passwordInput > div {
  position: relative;
}

#passwordInput > div label{
  position: absolute;
  top: 24px;
  right: 11px;
  font-size: 26px;
}

.outline-btn {
  border: solid 1.6px #dfdfdf;
  border-radius: 7px;
  background-color: rgba(121, 121, 121, 0.29);
}

.g-recaptcha {
  transform: scale(1.14);
  transform-origin: 0px 0px;
  margin-top: 35px;
}
</style>



// WEBPACK FOOTER //
// src/views/login/jLogin.vue